import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { EDIT_SALES_FUNNEL_LABEL } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { usePageContext } from '@app/providers/PageProvider/usePageContext';
import { handleCatchError } from '@app/services';
import { useGetSalesFunnelQuery } from '@app/services/rtkQuery/SalesFunnels/api';
import type { NFunnels } from '@app/types';

export const useEditSalesFunnelPageHeaderEffects = () => {
  const [query] = useSearchParams();
  const id = query.get('id');

  const [currentSalesFunnel, setCurrentSalesFunnel] =
    useState<NFunnels.SalesFunnelDto | null>(null);

  const { activeBranchId } = useUserPrint();

  const { showNotification } = useNotification();
  const { setTitleData } = usePageContext();

  const {
    data: currentSalesFunnelData,
    error: salesFunnelError,
    refetch: refetchGetSalesFunnel,
  } = useGetSalesFunnelQuery(
    {
      id,
      ActiveBranchId: activeBranchId,
    },
    {
      skip: !activeBranchId || !id,
    }
  );

  useEffect(() => {
    refetchGetSalesFunnel();

    return () => setTitleData('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setTitleData]);

  useEffect(() => {
    if (currentSalesFunnelData) {
      currentSalesFunnelData.Name
        ? setTitleData(currentSalesFunnelData.Name)
        : setTitleData(EDIT_SALES_FUNNEL_LABEL);
      setCurrentSalesFunnel(currentSalesFunnelData);
    } else {
      setTitleData(EDIT_SALES_FUNNEL_LABEL);
    }
  }, [currentSalesFunnelData, setCurrentSalesFunnel, setTitleData]);

  useEffect(() => {
    if (salesFunnelError) {
      showNotification(handleCatchError(salesFunnelError));
    }
  }, [salesFunnelError, showNotification]);

  return {
    currentSalesFunnel,
    refetchGetSalesFunnel,
  };
};
